module.exports = __webpack_public_path__ + "img/slide6.da1c7f66.png";